import { gameConstants } from '../constants';
import { gameService } from '../services';
import { showToast } from '../services/toast';

export const gameActions = {
  fetchGames,
  createGame,
  updateGame,
  updateGameSequence
};

function fetchGames() {
  return dispatch => {
    dispatch(request());

    gameService.fetchGames()
      .then(
        response => {
          dispatch(success(response.data));
        },
        error => {
          dispatch(failure(error));
        }
      );
  };

  function request() { return { type: gameConstants.FETCH_GAME_REQUEST } }
  function success(games) { return { type: gameConstants.FETCH_GAME_SUCCESS, games } }
  function failure(error) { return { type: gameConstants.FETCH_GAME_FAILURE, error } }
}

function createGame(gameDetails) {
  return dispatch => {
    dispatch(request());

    return gameService.createGame(gameDetails)
      .then(
        response => {
          dispatch(success(response.data));
          return response;
        },
        error => {
          dispatch(failure(error.toString()));
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
          return Promise.reject(error);
        }
      );
  };

  function request() { return { type: gameConstants.CREATE_GAME_REQUEST } }
  function success(games) { return { type: gameConstants.CREATE_GAME_SUCCESS, games } }
  function failure(error) { return { type: gameConstants.CREATE_GAME_FAILURE, error } }
}

function updateGame(gameDetails) {
  return dispatch => {
    dispatch(request());

    return gameService.updateGame(gameDetails)
      .then(
        response => {
          dispatch(success(response.data));
          return response;
        },
        error => {
          dispatch(failure(error.toString()));
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
          return Promise.reject(error);
        }
      );
  };

  function request() { return { type: gameConstants.UPDATE_GAME_REQUEST } }
  function success(games) { return { type: gameConstants.UPDATE_GAME_SUCCESS, games } }
  function failure(error) { return { type: gameConstants.UPDATE_GAME_FAILURE, error } }
}

function updateGameSequence(sequenceDetails) {
  return dispatch => {
    dispatch(request());

    return gameService.updateGameSequence(sequenceDetails)
      .then(
        response => {
          dispatch(success(response.data));
          return response;
        },
        error => {
          dispatch(failure(error.toString()));
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
          return Promise.reject(error);
        }
      );
  };

  function request() { return { type: gameConstants.UPDATE_SEQUENCE_REQUEST } }
  function success(games) { return { type: gameConstants.UPDATE_SEQUENCE_SUCCESS, games } }
  function failure(error) { return { type: gameConstants.UPDATE_SEQUENCE_FAILURE, error } }
}